import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
// import { UrlService } from '@core/services/url/url.service';
import { File } from '@core/objects/file';
import { FilesListItemMenuClick } from '../files-list-item-menu-click';


import { PreviewRequest, PreviewPageProperty } from '@core/objects/preview-request';
import { PreviewsService } from '@core/services/previews/previews.service';

@Component({
    selector: 'core-files-list-notes-grid-item',
    templateUrl: './notes-grid-item.component.html',
    styleUrls: ['./notes-grid-item.component.scss']
})
export class FilesListsNotesGridItemComponent implements OnInit {

    public readonly PRELOAD_PAGES = 3;

    @Input() file: File;
    @Input() displayed: boolean;
    @Input() notes: number = null;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    
    @Output() actionClick= new EventEmitter<File>();
    @Output() menuClick = new EventEmitter<FilesListItemMenuClick>();
    @Output() iconDownloadClick = new EventEmitter<File>();
    
    public preview: PreviewRequest = {
        date: "",
        id_file: "",
        total_pages: 0,
        status_code: 0,
        status_text: "PENDING",
        page_properties: []
    };
    public page = 1;
    public properties: PreviewPageProperty = null;

    protected previewSubscriptor : Subscription;

    
    constructor(private prwSrv: PreviewsService) { }

    ngOnInit() {
        this.previewSubscriptor = this.prwSrv.getSubscriptor(this.file).subscribe(preview => {
            // this.properties = preview.page_properties[0];
            this.preview = preview;
        });

        this.prwSrv.load(this.file);
    }

    previousPage(e) : void {
        e.stopPropagation();
        if (this.page > 1) {
            this.page--; // Go to the previous page only if not on the first page
        }

    }

    nextPage(e) : void {
        e.stopPropagation();
        if (this.page < this.preview.total_pages) {
            this.page++; // Go to the next page only if not on the last page
        }
    }

    getDeactivePages(){
        return Array.from({ length: this.preview.total_pages }, (_, index) => index + 1).filter((pageNumber) => pageNumber !== this.page);

    }

    onMenuSelect(key: string) {
        this.menuClick.emit({key: key, file: this.file});
    }

    actionDownloadClick(file: File, event: any){
        this.iconDownloadClick.emit(file);
        event.stopPropagation();
    }
}
